import { HistoriqueCguSignataireDecision } from './../../../services/cgu/cgu.service';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CguService, CguSignataireDecision, DecisionStateEnum} from 'src/app/services/cgu/cgu.service';
import moment from 'moment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PdfLibService } from 'src/app/services/pdf-lib/pdf-lib.service';
import { TestService } from 'src/app/services/test/test.service';

const TITLE = 'À propos';
interface HistoriqueCguSignataireDecisionCustom extends HistoriqueCguSignataireDecision {
  decisionStateLabel?: string;
  decisionDateStr?: string;
}
interface CguSignataireDecisionCustom extends CguSignataireDecision {
  decisionStateLabel?: string;
}
@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  public title = TITLE;

  public dmpHomologationEditeur = 'Oppysoft';
  public dmpHomologationNom = environment.dmpLegalInfos.nom;
  public dmpHomologationDate = environment.dmpLegalInfos.date;
  public dmpHomologationVersion = environment.dmpLegalInfos.version;
  public dmpIcanopeeHomologationDate = environment.dmpIcanopeeLegalInfos.date;
  public dmpIcanopeeHomologationVersion = environment.dmpIcanopeeLegalInfos.version;
  public currentProfil: any;
  public historiqueCgu: Array<HistoriqueCguSignataireDecisionCustom>;
  public currentCgu: CguSignataireDecisionCustom;
  public decisionStateEnum = DecisionStateEnum;
  public cguPdf: string;
  public isLoading = false;
  constructor(
    private _cguSrv: CguService,
    private _domSanitizer: DomSanitizer,
    private _pdfLibSrv: PdfLibService,
    private _testSrv: TestService
  ) { }

  async ngOnInit(): Promise<void> {
    try {
      const getenvData = await this._testSrv.passageCoGetenv();
      console.log(getenvData);
    } catch (error) {
      console.error('passageCoGetenv error:', error);
    }

    const currentProfilJson = localStorage.getItem('currentProfil');
    if (currentProfilJson && currentProfilJson !== '') {
        this.currentProfil = JSON.parse(currentProfilJson);
    }
    await this._initHistoriqueDecisionsCgu();

    // this.cguPdf = this._domSanitizer.bypassSecurityTrustResourceUrl(this.currentCgu.currentCguContent);

  }

  private async _initHistoriqueDecisionsCgu(): Promise<void> {
      try {
        if (this.currentProfil && this.currentProfil.idUtilisateur) {
          this.isLoading = true;
          //TODO le service n'existe pas le endpoint retour le contentpdf que si non signé ou inconnu
          const currentCguContent = await this._cguSrv.getCguDecision('fakevalue');
          this.cguPdf = currentCguContent.currentCguContent;
          //on recupere la decision reelle du user
          this.currentCgu = await this._cguSrv.getCguDecision(this.currentProfil.idUtilisateur);
          this.currentCgu.decisionStateLabel = this._cguSrv.getDecisionStateEnumLabel(this.currentCgu.currentCguDecisionState);

          //on recupere l'historique des statut CGU du user
          this.historiqueCgu = [];
          const historique: Array<HistoriqueCguSignataireDecisionCustom> = await this._cguSrv.getHistoriqueCguDecision(this.currentProfil.idUtilisateur);
          for (const cgu of historique) {
            cgu.decisionDateStr = moment(cgu.decisionDate).format('DD-MM-YYYY à HH:mm:ss');
            cgu.decisionStateLabel = this._cguSrv.getDecisionStateEnumLabel(cgu.decisionState);
          }
          historique.sort((a, b) => new Date(b.decisionDate).getTime() - new Date(a.decisionDate).getTime());
          this.historiqueCgu = historique;
        }
      } catch (error) {
        console.error(error);
      }finally {
        this.isLoading = false;
      }
  }

  async onDownloadCgu(event: MouseEvent) {
    event.preventDefault();

    // Texte du filigrane personnalisé
    const watermarkText = `Accepté par ${this.currentProfil.utilisateur.nom.toUpperCase()} ${this.currentProfil.utilisateur.prenom};login : ${this.currentProfil.utilisateur.email}; le ${this.historiqueCgu[0].decisionDateStr}`;


    // Ajout du filigrane via le service
    const pdfWithWatermark = await this._pdfLibSrv.addWatermarkSecu(this.cguPdf, watermarkText);

    // Extraire la base64 (on a une data URI complète ici)
    const base64 = pdfWithWatermark.split(',')[1];
    const byteArray = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    // Déclenche le téléchargement
    const a = document.createElement('a');
    a.href = url;
    a.download = 'HMO_CGU_accept.pdf';
    a.click();

    URL.revokeObjectURL(url);
  }
}
